import { capitalized } from "../../../../core/formatters"
// import { Series, type SeriesOptions } from "../../../models/series"
// import type { SeriesDOV1, TimeValueDataObject } from "../../data-object/graph"
// import { timeValueFromDataObject } from "./points-do.transforms"

// const SERIES_NAME_DELIMITERS = ['_Protocol', '_CMC', '_TVL', '_MarketCap', '_USD', '_Spot', '_AUM', '_RWA',
//     '_Private', 'ETH_Network', '_Correlation', 'Returns_CryptoVsIndexes', '_Futures', '_Volumes',
//     '_ETH_Staked', '_ETF_ETH', '_ETF_BITCOIN',
//     'Returns_Indices_and_Crypto_Returns', "_Stablecoin","_Daily"]

// const ensureValueFilter = (timeValue: TimeValueDataObject) => typeof timeValue.value === 'number'
// const seriesNameFromDataObject = (s: SeriesDOV1) => s.name.split(delimitersRegex)[0].replace(/_/g, ' ')

// const delimitersRegex = new RegExp(SERIES_NAME_DELIMITERS.join('|'))

// export const seriesFromDataObject = (seriesDO:SeriesDOV1, options: SeriesOptions): Series => {
//     const name = capitalized(seriesNameFromDataObject(seriesDO))
//     const timeValues = seriesDO.raw_data.filter(ensureValueFilter).map(timeValueFromDataObject)
//     return new Series(name, timeValues, options)
// }

const SERIES_NAME_DELIMITERS = ['_Protocol', '_CMC', '_TVL', '_MarketCap', '_Spot', '_AUM', '_RWA',
    '_Private', 'ETH_Network', '_Correlation', 'Returns_CryptoVsIndexes', '_Futures', '_Volumes',
    '_ETH_Staked', '_ETF_ETH', '_ETF_BITCOIN',
    'Returns_Indices_and_Crypto_Returns', "_Stablecoin", "_Daily", "aum", "eth_network", "stablecoins", '_tbills', '_Total_Flow']
export const seriesNameFromDataObject = (s: string) => capitalized(s.split(delimitersRegex)[0].replace(/_/g, ' '))
const delimitersRegex = new RegExp(SERIES_NAME_DELIMITERS.join('|'))